import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, tap } from 'rxjs/operators';
import { Observable, EMPTY } from 'rxjs';

import * as CommonStoreActions from './common-store.actions';
import { ContentService } from 'src/app/shared/services/content.service';
import { Store } from '@ngrx/store';

@Injectable()
export class CommonStoreEffects {
    loadCommonStores$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CommonStoreActions.loadCommonStores),
            /** An EMPTY observable only emits completion. Replace with your own observable API request */
            concatMap(() => EMPTY as Observable<{ type: string }>)
        );
    });

    loadHelpLinks$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(CommonStoreActions.loadHelpLinks),
                tap(() =>
                    this.contentService.getHelp().subscribe((data) => {
                        this.store.dispatch(
                            CommonStoreActions.loadHelpLinksSuccess({
                                helpLinks: data,
                            })
                        );
                    })
                )
            );
        },
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private contentService: ContentService,
        private store: Store
    ) {}
}
